module.exports = __webpack_public_path__ + "static/media/plus.b06695d5.svg";